const lang = {
    locale: "zh-CN",
    cancel: '取消',
    close: '关闭',
    ok: '确定',
    country: {
        china: '中国',
        hongKong: '中国香港',
        macau: '中国澳门',
        taiwan: '中国台湾',
        singapore: '新加坡',
        malaysia: '马来西亚',
        indonesia: '印度尼西亚',
        thailand: '泰国',
        philippines: '菲律宾',
        vietnam: '越南',
        myanmar: '缅甸'
    },
    friendlyTime: {
        just: '刚刚',
        yesterday: '昨天',
        oneMinuteAgo: '1分钟前',
        minutesAgo: '分钟前',
        oneHourAgo: '1小时前',
        hoursAgo: '小时前',
        daysAgo: '天前',
        weeksAgo: '周前',
    },
    enterTheContent: '请输入内容',
    multilingual: '多语',
    loading: '加载中…',
    select: '请选择',
    page: {
        loadMore: '加载更多',
        loading: '正在加载',
        noMore: '没有更多数据了'
    },
    empty: {
        data: '暂无数据',
        search: '搜索无结果',
        develop: '正在建设中、正在努力维护中',
        network: '暂无网络',
        server: '服务器出错了',
        404: '404',
        approve: '认证、审核请耐心等待',
    },
    pagination: {
        total: "共",
        item: "条",
        items: "条",
        page: "条/页",
        goto: "跳至",
        pageItem: "页"
    },
    selectMember: {
        all: '全部',
        title: '选择人员',
        titleRange: '选择范围',
        selected:'已选择',
        search: '搜索',
        clear:'清空',
        cancel:'取消',
        ok:'确定',
        recentMember: '最近联系人',
        dept:'组织',
        deptMember:'组织成员',
        group:'内部群',
        groupMember:'内部群成员',
        team:'组',
        teamMember:'组内成员',
        member:'成员',
        role: '角色',
        roleMember: '角色成员',
        external: '外部',
        externalMember: '外部人员',
        other: '其他',
        includingSubordinate: '包含下级',
        cancelSubordinate: '取消下级',
        includingSubordinateOrg: '包含下级组织',
        cancelSubordinateOrg: '取消下级组织',
        publicTeam: '公共组',
        privateTeam: '个人组',
        maximum: '已超出最大限制',
        enterKeywordToSearch: '输入关键字搜索'
    },
    datepicker: {
        selectDate: "选择日期",
        selectTime: "选择时间",
        startTime: "开始时间",
        endTime: "结束时间",
        clear: "清空",
        ok: "确定",
        datePanelLabel: "[yyyy年] [m月]",
        month: "月",
        month1: "1 月",
        month2: "2 月",
        month3: "3 月",
        month4: "4 月",
        month5: "5 月",
        month6: "6 月",
        month7: "7 月",
        month8: "8 月",
        month9: "9 月",
        month10: "10 月",
        month11: "11 月",
        month12: "12 月",
        year: "年",
        weekStartDay: "0",
        weeks: {
            sun: "日",
            mon: "一",
            tue: "二",
            wed: "三",
            thu: "四",
            fri: "五",
            sat: "六"
        },
        months: {
            m1: "1月",
            m2: "2月",
            m3: "3月",
            m4: "4月",
            m5: "5月",
            m6: "6月",
            m7: "7月",
            m8: "8月",
            m9: "9月",
            m10: "10月",
            m11: "11月",
            m12: "12月"
        }
    },
    table: {
        noDataText: "暂无数据",
        noFilteredDataText: "暂无筛选结果",
        confirmFilter: "筛选",
        resetFilter: "重置",
        clearFilter: "全部"
    },
    upload: {
        file: '附件',
        addFile: '添加附件',
        download: '下载',
        upload: '上传',
        secretLevel: '密级',
        dragFilesHereToUpload: '拖动文件到此上传',
        batchDownload: '批量下载',
        preview: '预览',
        singleMaxSize: '单个附件最多s1%M',
        allowDownload: '允许下载',
        fileUploading: '上传附件',
        public: '公开',
        internal: '内部',
        secret: '秘密',
        confidential: '机密',
        pleaseSelectFileSecretLevel: '请选择附件密级',
        fileUploadFailed: '附件上传失败',
        fileExceedsSizeLimit: '附件超过单附件大小限制',
        emptyFileIsNotAllowedToUpload: '禁止上传空文件',
        upToCountFilesCanBeUploaded: '最多可以上传s1%个文件',
        pleaseSelectFile: '请选择附件',
        noFiles: '暂无附件',
        delete: '删除',
        deleteSucceeded: '删除成功',
        deleteFailed: '删除失败',
        noAuthorization: '无权操作'
    }
}

export default lang
